// @core/api/endpoints/calendar/get_free_busy.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  GetFreeBusyRequest,
  GetFreeBusyResponse,
} from '../../../types/calendar';

const BASE_PATH = '/calendar';

/**
 * Get free/busy
 * Returns free/busy time slots for one or more users within a specified date range. Respects event visibility and calendar sharing permissions.
 */
export async function GetFreeBusy(
  data: GetFreeBusyRequest,
  options?: RequestOptions
): Promise<GetFreeBusyResponse> {
  const client = getApiClient();
  const requestPath = `${BASE_PATH}/availability/freebusy`;
  const requestOptions = options;
  return client.post<GetFreeBusyResponse>(requestPath, data, requestOptions);
}
